import { type QuizQuestion, QuizQuestionType } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { Type } from '@warp-drive/core/types/symbols';

import { TextQuestionEditorComponent } from '../editors/question/text.gts';
import { ReportingEditorComponent } from '../editors/reporting/reporting.gts';
import { TextResponseEditorComponent } from '../editors/response/text.gts';
import { TextScoringEditorComponent } from '../editors/scoring/text.gts';
import type { QuestionManager } from '../types/question-manager.ts';
import { DEFAULT_RESPONSE } from '../types/quiz-responses.ts';

export const TextQuestionManager: QuestionManager = {
  discriminator: (question: QuizQuestion) =>
    question.type === QuizQuestionType.Text,
  type: QuizQuestionType.Text,
  icon: 'ph:textbox',
  editingIcon: 'ph:textbox-fill',
  editingLabel: 'Field Type',
  label: 'Text Question',
  questionComponent: TextQuestionEditorComponent,
  scoringComponent: TextScoringEditorComponent,
  responseComponent: TextResponseEditorComponent,
  reportingComponent: ReportingEditorComponent,
  defaultData: {
    text: {
      [Type]: DataTypeQuiz.QuizQuestionText,
      multiline: false,
      score: 0,
      category: '',
      response: DEFAULT_RESPONSE,
      response0: DEFAULT_RESPONSE,
    },
    reporting: {
      [Type]: DataTypeQuiz.QuizReportingQuestion,
      groupName: '',
      questionName: '',
    },
  },
};
